/**
 * 메뉴 아이콘 화이트리스트.
 *
 * `import * as Icons from 'lucide-react'` 로 전체 아이콘 세트를 불러오면
 * 트리셰이킹이 불가능해져 번들에 1.5MB 가량이 통째로 실린다.
 * DB(icon_class)에 들어올 수 있는 이름만 명시적으로 import 해 사용한다.
 *
 * 새 메뉴에 새로운 아이콘을 쓰려면 여기에 한 줄 추가하면 된다.
 */
import {
  // 공통 / 대분류
  LayoutDashboard, Users, Briefcase, Package, ClipboardList, Settings,
  Bell, FileText, FolderKanban, Target, FileSpreadsheet, Database,
  ArrowLeftRight, Box, ListTodo, BarChart, BarChart3, UserCog, ShieldCheck,
  Network, Building, Building2, Home, LayoutGrid, Circle, HelpCircle,
  // 전자결재(예정)
  FileSignature, Inbox, Send, Stamp, CheckCircle2, XCircle, FilePen, ScrollText,
  // 자원관리(예정)
  CalendarDays, CalendarClock, CarFront, MonitorSmartphone, DoorOpen, Wrench,
  // 인사관리(예정)
  UserRound, CalendarCheck, Clock, Plane, IdCard, Activity,
  // 기타
  User, Search, Star, Folder, Tag, Mail, Phone, Truck, Receipt, Wallet,
} from 'lucide-react';

/** icon_class 문자열 → 컴포넌트 */
export const ICON_MAP = {
  LayoutDashboard, Users, Briefcase, Package, ClipboardList, Settings,
  Bell, FileText, FolderKanban, Target, FileSpreadsheet, Database,
  ArrowLeftRight, Box, ListTodo, BarChart, BarChart3, UserCog, ShieldCheck,
  Network, Building, Building2, Home, LayoutGrid, Circle, HelpCircle,
  FileSignature, Inbox, Send, Stamp, CheckCircle2, XCircle, FilePen, ScrollText,
  CalendarDays, CalendarClock, CarFront, MonitorSmartphone, DoorOpen, Wrench,
  UserRound, CalendarCheck, Clock, Plane, IdCard, Activity,
  User, Search, Star, Folder, Tag, Mail, Phone, Truck, Receipt, Wallet,
};

/**
 * DB 에 남아 있는 antd / fontawesome 잔재를 lucide 이름으로 흡수한다.
 * (예: tbl_menus 의 'TeamOutlined', 'fa-sitemap')
 */
export const ICON_ALIASES = {
  TeamOutlined: 'Users',
  UserOutlined: 'User',
  'fa-sitemap': 'Network',
};

export const FALLBACK_ICON = Circle;

export const resolveIconComponent = (name) => {
  if (!name) return FALLBACK_ICON;
  const resolved = ICON_ALIASES[name] || name;
  return ICON_MAP[resolved] || FALLBACK_ICON;
};
